import wixData from 'wix-data';
import wixLocation from 'wix-location';
import { biLoggerFactory } from 'wix-private';
const biLogger = biLoggerFactory('lp', 19, { msid: 'cea1e625-ef4a-40d7-bef8-2d50ce63a50e' });

$w.onReady(async function () {
    pageEvents();
});
async function pageEvents() {
    $w("#input2").onFocus(() => {
        $w('#warning').hide();
        $w('#text125').show();
        $w('#input2').placeholder = ''
    })
    $w("#input2").onKeyPress(() => {
        $w('#warning').hide();
        $w('#text125').show();
        $w('#input2').placeholder = ''
    })

    $w("#input2").onBlur(() => {
        if ($w("#input2").value === '') {
            $w('#text125').hide();
            $w('#input2').placeholder = 'Business email'
        }
        setTimeout(() => {
            console.log($w("#input2").valid)
            $w("#input2").valid ? $w('#warning').hide() : $w('#warning').show();
        }, 100)

    })

    $w("#input2").onChange(() => {
        if ($w("#input2").value === '') {
            $w('#text125').hide();
            $w('#input2').placeholder = 'Business email'
        }
        setTimeout(() => {
            console.log($w("#input2").valid, 'change')
            $w("#input2").valid ? $w('#warning').hide() : $w('#warning').show();
        }, 200)
    })

    $w('#buttonSubmit1').onClick(async () => {
        $w('#buttonSubmit1').disable();
        if ($w("#input2").valid) {
            await sendFormData();
        } else {
            $w('#buttonSubmit1').enable();
        }
    })
}

async function sendFormData() {
    const formData = {
        email: $w('#input2').value,
        source: wixLocation.url
    }
    let item = await wixData.insert("blogsubscribeDB", formData);

    const biEventObject = {
        evid: 703,
        button_name: 'subscribe_to_blog',
        is_valid: true,
        topic: 'partners lp',
        url: wixLocation.url
    };
    biLogger.log(biEventObject);

    console.log('sent')
    await wixLocation.to('https://www.wix.com/partners/blog-all-set')
}
